<script>
    import { url_join } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url.js?1733898724879';
    import { onMount } from 'svelte';
    import { clerk } from '/srv/web/wyvr/html/releases/58819/gen/client/clerk/store/clerk.js?1733898724879';

    wyvr: {
        render: 'hydrate';
        loading: 'interact';
    }

    export let store;
    export let api_token = "rskwN80ymWg8cBtkOC2ybhuHoxigDhNo";

    $: action = url_join(store, 'search');

    onMount(() => {
        clerk.load(api_token);
    });
    ;
</script>

<div class="m-searchbar">
    <section>
        <div class="c-search">
            <div class="c-search__input-wrapper">
                <form {action}>
                    <input id="search" name="q" type="text" placeholder={window.__('search.search')} />
                    <label for="search">
                        <button class="btn btn--small btn--search" type="submit">
                            <span
                                style="
                                    clip: rect(0 0 0 0);
                                    clip-path: inset(50%);
                                    height: 1px;
                                    overflow: hidden;
                                    position: absolute;
                                    white-space: nowrap;
                                    width: 1px;
                                ">{window.__('search.search')}</span
                            >
                        </button>
                    </label>
                </form>
                <div
                    class="clerk"
                    data-template="@live-search"
                    data-instant-search="#search"
                    data-instant-search-suggestions="6"
                    data-instant-search-categories="6"
                    data-instant-search-pages="6"
                    data-instant-search-positioning="center"
                />
            </div>
        </div>
    </section>
</div>


<style>
    section {
        position: relative;
        height: 100%;
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
    }
    form {
        display: flex;
        justify-content: center;
    }
    button {
        background-color: #040b1c;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 15px;
        text-decoration: none;
        border: 1px solid transparent;
        transition: 1s;
    }
    button:hover {
        color: #fef8e9;
        background: #707070;
        border: 1px solid #707070;
        text-decoration: none;
        outline: none;
        transition: 1s;
    }
    button:before {
        font-size: 21px;
        display: inline-block;
        font-style: normal;
        font-weight: normal;
        text-transform: none;
        line-height: 1;
        color: white;
        margin-right: 0px;
        content: '';
        font-family: kofferworld !important;
        font-variant: normal;
    }

    input {
        margin-top: 0;
        margin-bottom: 0;
        min-width: 250px;
        background: #fef8e9;
        color: #303133;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1;
        padding: 10px 20px;
        border: none;
        border-radius: none;
        outline: none;
        -webkit-box-shadow: none;
        box-shadow: none;
        -webkit-transition: -webkit-box-shadow 0.5s ease-in-out;
        transition: -webkit-box-shadow 0.5s ease-in-out;
        transition: box-shadow 0.5s ease-in-out;
        transition: box-shadow 0.5s ease-in-out, -webkit-box-shadow 0.5s ease-in-out;
    }
</style>